import { defineComponent, ref } from 'vue';
export default defineComponent({
  name: 'App',
  setup: function setup() {
    var showDlg = ref();
    showDlg.value = false;

    var updateVisible = function updateVisible() {
      showDlg.value = false;
    };

    var close = function close() {
      console.log('dialog closed!');
    };

    var toggleScreen = function toggleScreen(is_max) {
      console.log('dialog is max:', is_max);
    };

    return {
      showDlg: showDlg,
      updateVisible: updateVisible,
      close: close,
      toggleScreen: toggleScreen
    };
  }
});